import * as turf from '@turf/turf';
import drawing from '../map/draw';
import translate from '../tools/translate';

const LayerInfo = (name) => require('../../info').get(name);

class Summary {
    constructor (area) {
        let shape;

        if (area.layerType === 'circle') {
            shape = turf.buffer(area.layer.toGeoJSON(), area.layer.getRadius(), { units: 'meters' });
        } else {
            shape = area.layer.toGeoJSON();
        }

        if (turf.area(shape) > 1000000000) {
            alert('Ferramenta de área livre funciona somente para área até 1000 km².');
            return drawing.removeLayer();
        }

        const options = {
            title: translate('Common.SelectedLocation'),
            context: 'area-selection',
            geojson: shape,
            method: 'Draw',
            type: 'quadrante',
            visible: true,
            id: 1
        };

        LayerInfo('Summary').create(options);
    }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/Summary.js